import React, { useEffect, useRef, useState } from 'react'

/**
 * Renders a ZionCMS component given the components name.
 * This allows `RenderZionCMSItem` to work without importing all the components at once, reducing the bundle size.
 */
export default function DynamicZionCMSComponent({ component, ...props }: { component: string }): JSX.Element {
  const RefComponent = useRef<React.ElementType>()
  const [, setComp] = useState<string>()

  useEffect(() => {
    import(
      /* webpackExclude: /(\.test\.*|\.stories\.*|\.d\.ts)/ */
      `../../components/${component}`
    )
      .then(({ default: theComponent }) => {
        RefComponent.current = theComponent
        setComp(component)
      })
      .catch((error) => {
        console.error(`Unsupported component type: "${component}".\n\n`, error)
      })
  }, [component])

  if (!RefComponent.current) return <></>

  const Component = RefComponent.current

  return <Component {...props} />
}
